import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-row",
  "use": "icon-row-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-row\"><defs><style></style></defs><path d=\"M152 854.857h325.715V237.716H134.857v600q0 6.993 5.075 12.068T152 854.857zm737.143-17.142v-600H546.284v617.142H872q6.994 0 12.068-5.074t5.075-12.068zm68.572-651.43v651.43q0 35.383-25.167 60.55T872 923.427H152q-35.383 0-60.548-25.165t-25.168-60.548v-651.43q0-35.383 25.167-60.55T152 100.573h720q35.383 0 60.548 25.165t25.167 60.548z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol